import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/transitional/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { OTHER } from 'marketplace-ui-common/constants/Industry';
import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import Review from '../records/Review';
import { PREFER_NOT_TO_SAY } from '../constants/CompanySize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewerInfo({
  inline = false,
  review
}) {
  const {
    avatarUrl,
    companyName,
    showAvatar,
    reviewerDisplayName,
    employees,
    marketplaceIndustry,
    offeringVersion
  } = review;
  const renderedName = useMemo(() => {
    if (reviewerDisplayName) {
      return /*#__PURE__*/_jsx(FormattedName, {
        name: reviewerDisplayName
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.defaultName"
    });
  }, [reviewerDisplayName]);
  const renderedReviewerInfoText = useMemo(() => {
    const showEmployees = employees && employees !== PREFER_NOT_TO_SAY;
    const showIndustry = marketplaceIndustry && marketplaceIndustry !== OTHER;
    const employeeString = Review.toEmployeeString(employees);
    if (inline) {
      return /*#__PURE__*/_jsxs(List, {
        inline: true,
        use: "inline-divided",
        "data-test-id": "reviewer-info-list",
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "h7",
            children: renderedName
          })
        }), showIndustry && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `marketplace-ui-common.industry.${marketplaceIndustry}.title`
            })
          })
        }), showEmployees && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "small",
            children: employeeString
          })
        }), offeringVersion && /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-reviews.versionInfoText",
              options: {
                offeringVersion
              }
            })
          })
        })]
      });
    }
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      "data-test-id": "reviewer-info-flex",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h7",
        marginBlockEnd: "100",
        children: renderedName
      }), showIndustry && /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `marketplace-ui-common.industry.${marketplaceIndustry}.title`
        })
      }), showEmployees && /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: employeeString
      }), offeringVersion && /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-reviews.versionInfoText",
          options: {
            offeringVersion
          }
        })
      })]
    });
  }, [inline, renderedName, employees, marketplaceIndustry, offeringVersion]);
  const renderedUserAvatar = useMemo(() => {
    const avatarSize = inline ? 'xs' : 'md';
    if (avatarUrl && showAvatar) {
      return /*#__PURE__*/_jsx(AvatarDisplay, {
        type: "contact",
        size: avatarSize,
        src: avatarUrl
      });
    } else {
      return /*#__PURE__*/_jsx(AvatarDisplay, {
        type: "contact",
        size: avatarSize
      });
    }
  }, [inline, avatarUrl, showAvatar]);
  if (companyName) {
    const displayName = reviewerDisplayName || I18n.text('marketplace-ui-reviews.defaultName');
    return /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h7",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "marketplace-ui-reviews.reviewerInfo_jsx",
          options: {
            displayName,
            companyName
          },
          elements: {
            Name: FormattedName
          }
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(MediaObject, {
    align: "center",
    itemLeft: renderedUserAvatar,
    "data-test-id": "reviewer-info",
    children: renderedReviewerInfoText
  });
}